import type { CheckedState } from '@radix-ui/react-checkbox';
import type { AnswerQuestionMultiple } from '@repo/types/questions/QuestionMultiple';

import { QuestionMultiple } from '@repo/lib/quiz/questions/class/QuestionMultiple';

import type { QuestionMultipleProps } from '@/components/features/quiz/question/question-resolver';

import { useQuestionState } from '@/hooks/questions';

export function useQuestionMultiple(questionMultipleProps: QuestionMultipleProps) {
  const { question, sectionIndex, questionIndex } = questionMultipleProps;

  const { getContent, setAnswer, getAnswer, exportedAnswer, getMarked } = useQuestionState<QuestionMultiple>(question, sectionIndex, questionIndex);
  const marked = getMarked();
  const userAnswer = getAnswer();
  const { answers } = getContent();
  const exportedUserAnswer = exportedAnswer();

  const isChecked = (answerId: string) => {
    const userAnswers = getAnswer();
    if (!userAnswers) return false;
    return userAnswers.some((answer) => answer.id === answerId);
  };

  const onCheckedChange = (answerId: string, checked: CheckedState) => {
    let userAnswers = getAnswer();
    if (!userAnswers) userAnswers = [];
    if (checked) {
      setAnswer([...userAnswers.map((a) => a.id), answerId]);
    } else {
      setAnswer(userAnswers.filter((a) => a.id !== answerId).map((a) => a.id));
    }
  };

  const getMarkedState = (answer: AnswerQuestionMultiple): boolean | undefined => {
    if (marked?.answers && userAnswer?.map((a) => a.id).includes(answer.id)) {
      return marked.answers.find((a) => a.id === answer.id)?.correct;
    }
    return undefined;
  };

  return {
    marked,
    answers,
    userAnswer,
    exportedUserAnswer,
    isChecked,
    onCheckedChange,
    getMarkedState,
  };
}
